<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :totalData="totalData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkboxChange="checkboxChange"
      @openInventoryActionForm="openInventoryActionForm"
      @openShortageForm="openShortageForm"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @exportFile="exportFile"
      >
        <template slot-scope="{ form }">
          <!-- <SearchTabs class="ml-2" v-model="isAllShipments" @change="reload" /> -->
          <el-badge
            v-if="allow('E')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              v-if="allow('E')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="exportFile(form)"
            >
              {{ $l('btn_export') || '导出' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckList" />
            </b-button>
          </el-badge>
          <el-badge
            v-if="allow('I')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
            :disabled="!checkedRowCount"
          >
            <b-button
              v-if="allow('I')"
              size="sm"
              class="ml-3"
              :disabled="!checkedRowCount"
              variant="outline-primary"
              @click="openInventoryActionForm('')"
            >
              {{ $l('btn_setting_inv_action') || '设置库存处理方式' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckList" />
            </b-button>
          </el-badge>
        </template>
      </PageHeader>
      <template #toolbar_btn>
        <SortFieldsPopover
          v-model="sortFields"
          funcListName="ftyPurchaseInvList"
          style="margin-right: 0.8em;"
          @change="reload"
        />
      </template>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <chooseTemplate
      @export-success="clearCheckList"
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
    />
    <el-dialog
      :title="$l('dialog_title_setting_inv_action') || '库存处理方式设置'"
      :visible.sync="showInventoryAction"
      width="360px"
      v-if="showInventoryAction"
      :before-close="close"
    >
      <el-form
        ref="form"
        v-if="showInventoryAction"
        :model="invActionForm"
        :rules="rules"
        size="small"
        label-width="120px"
        label-position="top"
      >
        <el-form-item
          :label="$l('form_title_inventoryAction') || '库存处理方式'"
          prop="inventoryAction"
        >
          <dict-select
            v-model="invActionForm.inventoryAction"
            url="/sys/common/dict/system"
            :body="{ dictType: 'inventoryAction' }"
            :placeholder="
              $l('placeholder_select_inventoryAction') || '请选择库存处理方式'
            "
            size="small"
            style="width: 100%"
            filterable
            clearable
          ></dict-select>
        </el-form-item>
        <el-form-item
          :label="$l('form_title_inventoryActionRemark') || '库存处理方式备注'"
          prop="inventoryActionRemark"
        >
          <el-input
            type="textarea"
            maxlength="500"
            show-word-limit
            size="small"
            :rows="6"
            :placeholder="
              $l('form_pl_title_inventoryActionRemark') ||
                '请输入库存处理方式备注'
            "
            v-model="invActionForm.inventoryActionRemark"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button type="primary" size="small" @click="saveInventoryAction">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </span>
    </el-dialog>
    <EditShortageForm
      v-if="shortageDialogOptions.visible"
      ref="editForm"
      :type="shortageDialogOptions.type"
      :visible.sync="shortageDialogOptions.visible"
      :amzPurchaseDetailCode="shortageDialogOptions.code"
      :purchaseQty="shortageDialogOptions.purchaseQty"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import EditShortageForm from '../edit-shortage-form'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
import SortFieldsPopover from '@/views/ecom/components/sort-fields-popover'
// import SearchTabs from './search-tabs.vue'
import chooseTemplate from '@/views/ecom/components/choose-template'
export default {
  mixins: [BaseTable, EditLoading],
  components: {
    PageMain,
    PageHeader,
    SortFieldsPopover,
    // SearchTabs,
    chooseTemplate,
    EditShortageForm,
  },
  data() {
    return {
      totalData: {},
      invActionForm: {},
      usePage: true,
      sortFields: [],
      isAllShipments: 'N',
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'ecom-ftyPurchaseInv',
        searchForm: {},
      },
      shortageDialogOptions: { visible: false, code: '' },
      rules: {
        inventoryAction: [
          {
            required: true,
            message:
              this.$l('form_pl_title_inventoryAction') || '请选择库存处理方式',
            trigger: 'change',
          },
        ],
        inventoryActionRemark: [
          {
            required: true,
            message:
              this.$l('form_pl_title_inventoryActionRemark') ||
              '请输入库存处理方式备注',
            trigger: 'blur',
          },
        ],
      },
      checkList: [],
      codes: [],
      showInventoryAction: false,
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkList?.length || 0
    },
  },
  methods: {
    async getData(form) {
      const params = {
        ...form,
        ...this.page,
        sortFields: this.sortFields,
        selectExpectedOutQty: true,
        supportAmzStoreSkuNo: true,
        isNotSku: 'N',
      }

      this.getTotalData(params)

      this.loading = true
      await this.getTableData(params)
      this.loading = false
    },
    async getTableData(params) {
      const res = await this.$api
        .ecomAmzFtyPurchaseDetailListingApi(params)
        .catch(() => null)
      if (res) this.setData(res)
    },
    async getTotalData(params) {
      this.totalData = {}
      const res = await this.$api
        .ecomAmzFtyPurchaseDetailListingTotalApi(params)
        .catch(() => null)
      this.totalData = res?.body || {}
    },
    clearCheckList() {
      this.$refs.main.removeCheckboxRow()
      this.checkList = []
    },
    openInventoryActionForm(amzPurchaseDetailCode) {
      if (amzPurchaseDetailCode) {
        this.codes = [amzPurchaseDetailCode]
      } else {
        this.codes = []
      }
      this.invActionForm = {}
      this.showInventoryAction = true
    },
    openShortageForm({ menuType, amzPurchaseDetailCode, purchaseQty }) {
      this.shortageDialogOptions = {
        visible: true,
        type: menuType,
        code: amzPurchaseDetailCode,
        purchaseQty,
      }
    },
    close() {
      this.codes = []
      this.invActionForm = {}
      this.showInventoryAction = false
    },
    async saveInventoryAction() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (this.loadingOpen()) return
      if (this.codes && this.codes.length < 1) {
        this.codes = this.checkList
      }
      const res = await this.$api
        .ecomAmzFtyPurchaseDetailUpdateInventoryActionApi({
          codes: this.codes,
          ...this.invActionForm,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('tips_save_inventory_action_ok') || res.msg,
        type: 'success',
      })
      this.close()
      this.clearCheckList()
      this.reload()
    },
    exportFile(form) {
      this.chooseTemplateOptions.visible = true
      this.chooseTemplateOptions.searchForm = {
        ...form,
        sortFields: this.sortFields,
        selectExpectedOutQty: true,
        supportAmzStoreSkuNo: true,
        isNotSku: 'N',
      }
      this.chooseTemplateOptions.searchForm.checkList = this.checkList
    },
    checkboxChange(data) {
      const tmp = data?.map((e) => e.amzPurchaseDetailCode || '') || []
      this.checkList = tmp.filter((e) => Boolean(e))
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
